import React from "react"

const KoniecCzasu = () => {
    return (
        <h4><span className="wyroznienie">Upłynął czas trwania konkursu</span></h4>)
}

export default KoniecCzasu